import { Brick, registerBrick, BrickContext } from 'olympe';
import LockDeviceAwake from "./LockDeviceAwake";
import {getLogger} from "@olympeio/core";

export default class UnlockDeviceAwake extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} inputs
     * @param {function()} forwardEvent
     */
    async update($, inputs, [forwardEvent]) {
        const logger = getLogger('Unlock Device Awake');
        if ('wakeLock' in navigator) {
            const root$ = LockDeviceAwake.getRootContext($);
            const lock = /** @type {WakeLockSentinel} */ (root$.get(LockDeviceAwake.LOCK_KEY));
            if (lock !== null) {
                try {
                    await lock.release();
                    root$.remove(LockDeviceAwake.LOCK_KEY);
                } catch (error) {
                    logger.warn(`${error.name}, ${error.message}`);
                } finally {
                    forwardEvent();
                }
            } else {
                logger.debug('No wake lock to release');
                forwardEvent();
            }
        } else {
            logger.warn('WakeLock not supported');
            forwardEvent();
        }
    }
}

registerBrick('018b7036517fd51c576d', UnlockDeviceAwake);
